import { memo } from "react";

import TableSimple from "ds/components/TableSimple";
import { IntentProject } from "types/generated";
import useAllItemsCount from "shared/IntentProject/useSearchIntentProjectsSuggestions/useAllItemsCount";
import TablePagination from "components/Table/Pagination";
import useIntentProjectsStore from "shared/IntentProject/useSearchIntentProjects/store";
import usePagination from "components/Table/Pagination/usePagination";

import useIntentProjectsTableStore from "./useIntentProjectsTableStore";
import { INTENT_PROJECTS_TABLE_CELLS } from "./Cells";
import {
  INTENT_PROJECTS_LIMIT_STORAGE_KEY,
  INTENT_PROJECTS_PAGINATION_OPTIONS,
  INTENT_PROJECTS_SORT_CONFIG,
  INTENT_PROJECTS_SORT_STORAGE_KEY,
} from "./constants";

type IntentProjectsTableProps = {
  intentProjects: IntentProject[];
  loading: boolean;
  startCursor: string | undefined;
  endCursor: string | undefined;
};

const IntentProjectsTable = ({
  intentProjects,
  loading,
  startCursor,
  endCursor,
}: IntentProjectsTableProps) => {
  const { allItemsCount } = useAllItemsCount();
  const { onFetchItems, rowsPerPage: initialLimit } = useIntentProjectsStore();

  const {
    rowsPerPage,
    setRowsPerPage,
    from,
    to,
    lastPage,
    page,
    goToNextPage,
    goToPrevPage,
    goToFirstPage,
    goToLastPage,
  } = usePagination({
    fetchItems: onFetchItems,
    startCursor,
    endCursor,
    allItemsCount,
    visibleItemsCount: intentProjects.length,
    initialLimit,
    storageKey: INTENT_PROJECTS_LIMIT_STORAGE_KEY,
  });

  return (
    <>
      <TableSimple
        data={intentProjects}
        loading={loading}
        store={useIntentProjectsTableStore}
        ariaLabel="Intent Projects table"
        cellPerColumn={INTENT_PROJECTS_TABLE_CELLS}
        filtersStorageKey={INTENT_PROJECTS_SORT_STORAGE_KEY}
        sortConfig={INTENT_PROJECTS_SORT_CONFIG}
      />

      <TablePagination
        from={from}
        to={to}
        loading={loading}
        goToNextPage={goToNextPage}
        setRowsPerPage={setRowsPerPage}
        goToPrevPage={goToPrevPage}
        goToFirstPage={goToFirstPage}
        goToLastPage={goToLastPage}
        rowsPerPage={rowsPerPage}
        itemsCount={allItemsCount}
        lastPage={lastPage}
        page={page}
        paginationOptions={INTENT_PROJECTS_PAGINATION_OPTIONS}
      />
    </>
  );
};

export default memo(IntentProjectsTable);
